import { BPopover } from 'bootstrap-vue';
import HowItWorksPopoverContents from '../components/HowItWorksPopoverContents';

export const baseStepper = {
  components: {
    BPopover,
    HowItWorksPopoverContents
  },
  data() {
    return {
      activeDot: 1,
      dotCount: 5,
    };
  },
  methods: {
    dotClass(index) {
      if (index < this.activeDot) {
        return '';
      } else if (index === this.activeDot) {
        return 'active';
      } else {
        return 'dulled';
      }
    },
  }
}